import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const PostSedationSAT = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Post-Sedation SAT</InputLabel>
      <Select
        value={moduleValues?.['Post-Sedation SAT'] ?? ''}
        label="Post-Sedation SAT"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Post-Sedation SAT']: e.target.value,
          }))
        }
      >
        {[
          '+3 (Combative, violent, out of control, continuous loud outbursts)',
          '+2 (Very anxious and agitated, aggressive)',
          '+1 (Anxious but reassurable, not aggressive)',
          '0 (Awake and calm, co-operative)',
          '-1 (Drowsy, eyes closed but rousable to voice)',
          '-2 (Responds only to physical stimulation)',
          '-3 (No response to voice or physical stimulation, unresponsive)',
        ].map((x, index) => (
          <MenuItem key={index} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default PostSedationSAT
